export default "/images/user.svg?acea09ddc5cf310a64705d34c4341b68";